import React from 'react';
import { FormattedMessage } from 'react-intl';

export default () => (
  <FormattedMessage
    id="account.signup.password-mismatch"
    defaultMessage="The password and confirmation do not match"
  />
);
